import React, { lazy, Suspense, useRef, useState } from 'react';
import { useVisibility } from '@wearejh/react-hooks/lib/useVisibility';

import { getAdvancedSettings } from '../advancedSettings';
import { PageBuilderElementWrapper } from '../PageBuilderElementWrapper';

import type { DynamicBlockType } from './dynamicBlockConfigAggregator';

type PageBuilderDynamicBlockProps = DynamicBlockType;

const LazyDynamicBlock = lazy(() => import('./components/DynamicBlock'));

/**
 * Return the PB Dynamic Block
 * @param props
 * @constructor
 */
export function PageBuilderDynamicBlock(props: PageBuilderDynamicBlockProps) {
    /**
     * Lazy load the ProductGrid and ProductCarousel components
     */
    const ref = useRef<HTMLDivElement | null>(null);
    const [isReady, setReady] = useState(false);
    const options: IntersectionObserverInit = {
        rootMargin: '75px',
    };
    useVisibility(ref, setReady, options);

    /**
     * Configure the styles requires for the Dynamic Block
     */
    const advancedSettings = getAdvancedSettings<PageBuilderDynamicBlockProps>(props);

    const dynamicBlockClassNames = ['pageBuilderDynamicBlockGlobal'];

    if (props.cssClasses && props.cssClasses.length > 0) {
        dynamicBlockClassNames.push(...props.cssClasses);
    }

    /**
     * Render the Dynamic Block UI
     */
    return (
        <PageBuilderElementWrapper
            contentType={props.contentType}
            uniqueID={props.uniqueID}
            styles={advancedSettings}
            classNames={dynamicBlockClassNames}
            ref={ref}
        >
            {isReady && (
                <Suspense fallback="...">
                    <LazyDynamicBlock {...props} />
                </Suspense>
            )}
        </PageBuilderElementWrapper>
    );
}
